/*
 * FEVR Penalty Shootout - game client.
 * Rendering + input only. In live mode every outcome (goal / save, lives, score, keeper level)
 * comes from the server; in practice mode the same rules run locally and nothing is ranked.
 */
(function () {
  'use strict';

  var R = window.FevrRules, Core = window.FevrCore, Art = window.FevrArt;
  if (!R || !Core || !Art) { if (window.console) console.error('FEVR game: missing rules/core/art scripts'); return; }

  var W = 180, H = 320;
  var CX = 90, GROUND = 112, BAR_TOP = 42, INNER_TOP = 45, HALF = 67;
  var BALL_X = 90, BALL_Y = 204;
  var METER = { x: 20, y: 254, w: 140, h: 8 };
  var BTN = { x: 30, y: 278, w: 120, h: 30 };
  var GOAL_HIT = { x0: 12, x1: 168, y0: 38, y1: 124 };

  var WINDUP_MS = 200, FLIGHT_MS = 380, DIVE_MS = 340, RESULT_MS = 900, LEVELUP_MS = 2100;

  var C = { INK: Art.INK, WHITE: Art.WHITE, G1: Art.GREY1, G2: Art.GREY2, G3: Art.GREY3, NEON: Art.NEON, CYAN: Art.CYAN, PINK: Art.PINK, RED: Art.RED };

  var MSG = {
    save: [
      'THE KEEPER READ YOUR MIND. RUDE.', 'STRAIGHT AT HIM. BOLD STRATEGY.', 'HE SMELLED THAT FROM THE HALFWAY LINE.',
      'THAT WAS A PASS, NOT A SHOT.', 'YOUR NAN PICKS BETTER CORNERS.', 'VAR CHECKED. STILL A SAVE.',
      'COMMENTATOR: HE\'LL WANT THAT ONE BACK.', 'EASIEST SAVE OF HIS CAREER.', 'THE KEEPER SENDS HIS REGARDS.'
    ],
    babySave: ['BEATEN BY A BABY. YOUR MUM WILL HEAR ABOUT THIS.', 'THE BABY IS NOW LAUGHING AT YOU.', 'SAVED BY A BABY. LET THAT SINK IN.'],
    miss: [
      'THAT\'S ORBIT, NOT A SHOT.', 'ROW Z SENDS ITS REGARDS.', 'AIMED FOR THE CAR PARK. NAILED IT.',
      'THE BALL IS NOW SOMEONE\'S SOUVENIR.', 'STEWARDS ARE LOOKING FOR THE BALL.', 'SATELLITES WILL TRACK THAT ONE.',
      'THE CORNER FLAG FEELS SAFE.', 'GOOGLE MAPS: BALL LAST SEEN IN THE STANDS.'
    ],
    post: ['THE WOODWORK SAYS NO.', 'POST: 1. YOU: 0.', 'THAT CLANG WILL ECHO IN YOUR HEAD.', 'SO CLOSE. SO CRUEL.', 'THE GOALPOST IS UNDEFEATED.'],
    last: ['FULL TIME. THE KEEPER WINS.', 'THE WHISTLE GOES. SO DO YOU.']
  };

  var API_ERRORS = {
    bad_timing: 'TIMING GLITCH. GO AGAIN.', too_early: 'HOLD ON, THE KEEPER IS NOT READY.', too_fast: 'EASY TIGER. GO AGAIN.',
    rate_limited: 'TOO MANY RUNS. TRY LATER.', drop_closed: 'THIS DROP HAS ENDED.', session_expired: 'RUN EXPIRED. START AGAIN.',
    no_session: 'RUN LOST. START AGAIN.'
  };

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function pad5(n) { n = String(n); while (n.length < 5) n = '0' + n; return n; }
  function pick(arr, lastRef) { var v; var n = 0; do { v = arr[Math.floor(Math.random() * arr.length)]; n++; } while (v === lastRef.v && n < 5 && arr.length > 1); lastRef.v = v; return v; }
  function pnow() { return (window.performance && performance.now) ? performance.now() : Date.now(); }
  function reduceMotion() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  /* ---------------- API adapters ---------------- */
  function localApi() {
    var n = 0;
    var game = Core.createGame({
      store: Core.MemoryStore(), now: Date.now,
      rand: function () { var a = []; for (var i = 0; i < 8; i++) a.push(Math.random()); return a; },
      newId: function () { return 'L' + (++n); }, newKey: function () { return 'k' + Math.random().toString(36).slice(2); },
      config: { dropId: 'practice', sessionsPerIpPerHour: 0 }
    });
    function later(v) { return new Promise(function (res) { setTimeout(function () { res(v); }, 60); }); }
    return {
      mode: 'practice',
      start: function () { return game.start({}).then(later); },
      shot: function (s, body) { return game.shot(s.sid, s.key, body).then(later); },
      submit: function () { return Promise.resolve({ ok: false, error: 'practice' }); },
      leaderboard: function () { return Promise.resolve({ ok: true, entries: [] }); }
    };
  }

  function remoteApi(base) {
    base = base.replace(/\/+$/, '');
    function call(method, path, body, timeoutMs) {
      var ctl = window.AbortController ? new AbortController() : null;
      var timer = ctl ? setTimeout(function () { ctl.abort(); }, timeoutMs || 8000) : null;
      return fetch(base + path, {
        method: method, mode: 'cors', credentials: 'omit', signal: ctl ? ctl.signal : undefined,
        headers: body ? { 'content-type': 'application/json' } : undefined, body: body ? JSON.stringify(body) : undefined
      }).then(function (r) {
        return r.json().catch(function () { return { ok: false, error: 'bad_response' }; }).then(function (j) { if (!j || typeof j !== 'object') j = { ok: false, error: 'bad_response' }; j.http = r.status; return j; });
      }).then(function (j) { if (timer) clearTimeout(timer); return j; }, function (e) { if (timer) clearTimeout(timer); var er = new Error('network'); er.network = true; throw er; });
    }
    return {
      mode: 'live',
      start: function () { return call('POST', '/api/start', {}); },
      shot: function (s, body) { return call('POST', '/api/shot', Object.assign({ sid: s.sid, key: s.key }, body)); },
      submit: function (s, nickname, email) { return call('POST', '/api/submit', { sid: s.sid, key: s.key, nickname: nickname, email: email }); },
      leaderboard: function () { return call('GET', '/api/leaderboard?limit=10'); }
    };
  }

  /* ---------------- audio / haptics ---------------- */
  function makeAudio() {
    var ac = null, muted = true;
    try { muted = window.localStorage.getItem('fevr_sound') !== '1'; } catch (e) { /* ignore */ }
    function ctx() { if (!ac) { var A = window.AudioContext || window.webkitAudioContext; if (A) ac = new A(); } if (ac && ac.state === 'suspended') ac.resume(); return ac; }
    function tone(f0, f1, dur, type, vol, delay) {
      if (muted) return; var a = ctx(); if (!a) return;
      var t = a.currentTime + (delay || 0), o = a.createOscillator(), g = a.createGain();
      o.type = type || 'square'; o.frequency.setValueAtTime(f0, t); if (f1) o.frequency.exponentialRampToValueAtTime(f1, t + dur);
      g.gain.setValueAtTime(vol || 0.06, t); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      o.connect(g); g.connect(a.destination); o.start(t); o.stop(t + dur + 0.02);
    }
    return {
      isMuted: function () { return muted; },
      unlock: function () { if (!muted) ctx(); },
      setMuted: function (m) { muted = m; try { window.localStorage.setItem('fevr_sound', m ? '0' : '1'); } catch (e) { /* ignore */ } if (!m) { ctx(); tone(660, 880, 0.08, 'square', 0.05); } },
      kick: function () { tone(200, 70, 0.1, 'square', 0.07); },
      goal: function () { [523, 659, 784, 1047].forEach(function (f, i) { tone(f, f, 0.09, 'square', 0.05, i * 0.07); }); },
      save: function () { tone(240, 110, 0.22, 'sawtooth', 0.06); },
      miss: function () { tone(170, 90, 0.3, 'triangle', 0.08); },
      level: function () { [330, 392, 494, 587, 659, 784, 988, 1175].forEach(function (f, i) { tone(f, f, 0.1, 'square', 0.04, i * 0.08); }); },
      over: function () { [392, 330, 262, 196].forEach(function (f, i) { tone(f, f * 0.98, 0.2, 'triangle', 0.07, i * 0.16); }); },
      tick: function () { tone(880, 880, 0.03, 'square', 0.03); }
    };
  }
  function buzz(p) { try { if (navigator.vibrate) navigator.vibrate(p); } catch (e) { /* ignore */ } }

  /* ---------------- the game ---------------- */
  function mount(root) {
    if (root.__fevr) return root.__fevr;
    var canvas = root.querySelector('canvas.fevr-game__canvas');
    var frameEl = root.querySelector('.fevr-game__frame');
    if (!canvas || !frameEl) return null;
    var ctx = canvas.getContext('2d', { alpha: false });
    var live = root.getAttribute('data-api');
    var api = live ? remoteApi(live) : localApi();
    var debug = root.getAttribute('data-debug') === 'true';
    var audio = makeAudio();
    var announcer = root.querySelector('.fevr-game__live');
    var k = 1; // device pixels per logical pixel
    var sprites = {};
    var lastMsg = { v: '' };

    var S = {
      phase: 'intro', sess: null, drop: null, rules: { lives: 3, points: 100 },
      score: 0, lives: 3, attempt: 0, level: 0, displayLevel: 0,
      aim: null, meterStart: 0, meterPeriod: 1700, meterSweet: 0.12,
      tShoot: 0, windupAt: 0, pending: null, flightAt: 0, impactAt: 0, res: null,
      dive: null, resultAt: 0, resultText: '', resultMsg: '', resultKind: '', levelupAt: 0, pendingLevelup: null,
      shakeUntil: 0, shakeAmp: 0, flashUntil: 0, flashColor: C.NEON, lifeFlashUntil: 0, floatAt: 0,
      best: 0, err: '', errUntil: 0, btnDownUntil: 0, practiceNote: api.mode === 'practice', ballSpin: 0, ballPos: null,
      overShown: false, streak: 0, mult: 1, lastDelta: 0, lvQuick: false, nextDelay: 0, lastRecv: 0, retryFn: null, submitted: false, lastEntry: null, kickAt: 0
    };
    try { S.best = parseInt(window.localStorage.getItem('fevr_best_' + api.mode) || '0', 10) || 0; } catch (e) { /* ignore */ }

    /* ----- sizing ----- */
    function resize() {
      var cs = window.getComputedStyle(root);
      var inner = root.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0) - 4; // minus frame border
      var availW = Math.max(160, inner || 360);
      var vh = window.innerHeight || 700;
      var availH = Math.max(280, vh * 0.88);
      var css = Math.min(availW / W, availH / H);
      var dpr = window.devicePixelRatio || 1;
      k = Math.max(1, Math.floor(css * dpr));
      canvas.width = W * k; canvas.height = H * k;
      canvas.style.width = (W * k / dpr) + 'px'; canvas.style.height = (H * k / dpr) + 'px';
    }
    resize();
    window.addEventListener('resize', resize);
    window.addEventListener('orientationchange', resize);

    function sprite(level, frameIdx) {
      var id = R.KEEPERS[level].id;
      var key = id + frameIdx;
      if (!sprites[key]) sprites[key] = Art.buildKeeperSprite(id, frameIdx);
      return sprites[key];
    }

    /* ----- flow ----- */
    function say(msg) { if (announcer) announcer.textContent = msg; }

    function startRun() {
      if (S.phase === 'starting') return;
      hidePanel();
      S.phase = 'starting'; S.err = '';
      api.start().then(function (res) {
        if (!res || res.ok === false) {
          if (res && res.error === 'drop_closed') { S.phase = 'intro'; flashErr('THIS DROP HAS ENDED.'); return; }
          if (res && res.error === 'rate_limited') { S.phase = 'intro'; flashErr('TOO MANY RUNS. TRY LATER.'); return; }
          throw new Error(res && res.error || 'start_failed');
        }
        beginRun(res);
      }).catch(function () {
        // can't reach the server: fall back to unranked practice so the page still works
        api = localApi(); S.practiceNote = true;
        api.start().then(beginRun);
      });
    }

    function beginRun(res) {
      S.sess = { sid: res.sid, key: res.key }; S.drop = res.drop || null; S.rules = res.rules || S.rules;
      S.score = res.state.score; S.lives = res.state.lives; S.attempt = res.state.attempt; S.level = S.displayLevel = res.state.level; S.streak = 0; S.mult = 1; S.bestStreak = 0;
      S.meterPeriod = res.state.meter.period; S.meterSweet = res.state.meter.sweet;
      armTurn(pnow(), res.nextDelayMs);
      S.submitted = false; S.lastEntry = null; S.overShown = false; S.res = null; S.pending = null; S.dive = null;
      S.phase = 'ready';
      say('Penalty shootout started. Tap the goal to aim.');
    }

    function armTurn(recvAt, delay) {
      S.aim = null; S.dive = null; S.res = null; S.pending = null; S.ballPos = null; S.resultKind = '';
      S.meterStart = recvAt + delay; S.nextDelay = delay;
    }

    function flashErr(msg) { S.err = msg; S.errUntil = pnow() + 2600; }

    function setAim(lx, ly) {
      if (S.phase !== 'ready') return;
      S.aim = { x: clamp((lx - CX) / HALF, -1, 1), y: clamp((GROUND - ly) / HALF, 0, 1) };
      audio.tick();
    }

    function shoot(evTime) {
      if (S.phase !== 'ready' || !S.aim) return;
      var now = pnow();
      var t = (evTime || now) - S.meterStart;
      if (t < 150) return; // meter not running yet (and nobody reacts that fast)
      S.phase = 'windup'; S.windupAt = now; S.tShoot = Math.round(t); S.btnDownUntil = now + 120;
      audio.kick();
      sendShot(0);
    }

    function sendShot(tries) {
      var body = { attempt: S.attempt, ax: Math.round(S.aim.x * 1000) / 1000, ay: Math.round(S.aim.y * 1000) / 1000, t: S.tShoot };
      api.shot(S.sess, body).then(function (res) {
        if (!res || res.ok === false) return shotRejected(res || {});
        S.pending = { res: res, recv: pnow() };
        S.nextDelay = res.nextDelayMs;
        S.nextMeterAt = pnow() + (res.nextDelayMs || 0); // the server starts its clock before this, so never start the meter earlier
      }).catch(function () {
        if (tries < 2) setTimeout(function () { sendShot(tries + 1); }, 600 * (tries + 1));
        else { S.phase = 'error'; S.retryFn = function () { S.phase = 'windup'; S.windupAt = pnow(); sendShot(0); }; }
      });
    }

    function shotRejected(res) {
      var code = res.error;
      if (code === 'bad_timing' || code === 'too_early' || code === 'too_fast' || code === 'conflict') {
        flashErr(API_ERRORS[code] || 'TRY AGAIN.');
        S.phase = 'ready'; S.aim = null; S.meterStart = pnow() + 900; return;
      }
      if (code === 'bad_attempt') { flashErr('OUT OF SYNC. START AGAIN.'); }
      else flashErr(API_ERRORS[code] || 'SOMETHING WENT WRONG.');
      S.phase = 'intro'; S.sess = null;
    }

    function applyImpact(now) {
      var res = S.pending.res, sh = res.shot;
      S.res = res; S.phase = 'result'; S.resultAt = now;
      S.score = res.state.score; S.lives = res.state.lives; S.attempt = res.state.attempt;
      S.streak = res.state.streak || 0; S.bestStreak = Math.max(S.bestStreak || 0, S.streak); S.mult = res.state.mult || 1; S.lastDelta = res.scoreDelta || 0; S.prevMult = S.mult;
      S.meterPeriod = res.state.meter.period; S.meterSweet = res.state.meter.sweet; S.level = res.state.level;
      S.pendingLevelup = res.levelUp ? res.nextKeeper : null;
      if (sh.goal) {
        S.resultKind = 'goal'; S.resultText = 'GOAL!'; S.resultMsg = '';
        var rm = reduceMotion();
        S.shakeUntil = now + (rm ? 0 : 520); S.shakeAmp = 5;
        S.flashUntil = now + 260; S.flashColor = C.NEON; S.floatAt = now;
        audio.goal(); buzz(35); say('Goal! ' + S.lastDelta + ' points. Score ' + S.score + '.');
      } else {
        var word = sh.result === 'save' ? 'SAVED!' : sh.result === 'wide' ? 'WIDE!' : sh.result === 'over' ? 'OVER!' : sh.result === 'post' ? 'POST!' : 'BAR!';
        S.resultKind = 'miss'; S.resultText = word;
        var pool = sh.result === 'save' ? (S.level === 0 || res.state.keeper.index === 0 ? MSG.babySave.concat(MSG.save) : MSG.save) : (sh.result === 'post' || sh.result === 'bar') ? MSG.post : MSG.miss;
        S.resultMsg = res.state.over && Math.random() < 0.5 ? pick(MSG.last, lastMsg) : pick(pool, lastMsg);
        S.lifeFlashUntil = now + 500; S.flashUntil = now + 160; S.flashColor = C.RED;
        if (sh.result === 'save') audio.save(); else audio.miss();
        buzz([60, 40, 60]); say(word.replace('!', '') + '. ' + S.resultMsg + ' Lives left ' + S.lives + '.');
      }
    }

    function afterResult(now) {
      var res = S.res;
      if (res.state.over) {
        if (!S.overShown && now - S.resultAt > 1300) { S.overShown = true; S.phase = 'over'; audio.over(); finishRun(); }
        return;
      }
      if (S.pendingLevelup) {
        var seen = seenKeepers(); S.lvQuick = !!seen[S.pendingLevelup.id]; S.lvSwapAt = S.lvQuick ? 220 : 600; S.lvTotal = S.lvQuick ? 1000 : LEVELUP_MS;
        S.phase = 'levelup'; S.levelupAt = now; S.levelFrom = S.displayLevel; S.swapped = false; S.dive = null; S.ballPos = null; audio.level(); say('Next keeper: ' + S.pendingLevelup.name + '.');
        return;
      }
      S.phase = 'ready'; S.displayLevel = S.level; S.dive = null; S.res = null; S.pending = null; S.aim = null; S.ballPos = null; S.resultKind = '';
      S.meterStart = Math.max(S.meterStart, S.nextMeterAt || 0, now + 200);
    }

    function seenKeepers() { try { return JSON.parse(window.localStorage.getItem('fevr_seen_keepers') || '{}') || {}; } catch (e) { return {}; } }
    function markSeen(id) { try { var o = seenKeepers(); o[id] = 1; window.localStorage.setItem('fevr_seen_keepers', JSON.stringify(o)); } catch (e) { /* ignore */ } }

    function afterLevelup() {
      S.phase = 'ready'; S.displayLevel = S.level; S.dive = null; S.res = null; S.pending = null; S.aim = null; S.ballPos = null; S.resultKind = ''; S.pendingLevelup = null;
      S.meterStart = Math.max(S.meterStart, S.nextMeterAt || 0, pnow() + 200);
    }

    function finishRun() {
      if (S.score > S.best) { S.best = S.score; try { window.localStorage.setItem('fevr_best_' + api.mode, String(S.best)); } catch (e) { /* ignore */ } S.newBest = true; } else S.newBest = false;
      showPanel('over');
    }

    /* ----- input ----- */
    function toLogical(e) {
      var r = canvas.getBoundingClientRect();
      return { x: (e.clientX - r.left) * (W / r.width), y: (e.clientY - r.top) * (H / r.height) };
    }
    function inBtn(p) { return p.x >= BTN.x - 6 && p.x <= BTN.x + BTN.w + 6 && p.y >= BTN.y - 8 && p.y <= BTN.y + BTN.h + 8; }
    function inMeter(p) { return p.x >= METER.x - 6 && p.x <= METER.x + METER.w + 6 && p.y >= METER.y - 8 && p.y <= METER.y + METER.h + 10; }
    function inGoal(p) { return p.x >= GOAL_HIT.x0 && p.x <= GOAL_HIT.x1 && p.y >= GOAL_HIT.y0 && p.y <= GOAL_HIT.y1; }

    canvas.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      e.preventDefault();
      var p = toLogical(e);
      audio.unlock();
      if (S.phase === 'intro') { startRun(); return; }
      if (S.phase === 'error') { if (S.retryFn) S.retryFn(); return; }
      if (S.phase === 'ready') {
        if (inGoal(p)) setAim(p.x, p.y);
        else if (inBtn(p) || inMeter(p)) shoot(e.timeStamp && e.timeStamp < 1e12 ? e.timeStamp : pnow());
      }
    });
    canvas.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    window.addEventListener('keydown', function (e) {
      if (!root.contains(document.activeElement) && document.activeElement !== document.body) return;
      if (panelOpen()) return;
      var key = e.key;
      if (S.phase === 'intro' && (key === 'Enter' || key === ' ')) { e.preventDefault(); startRun(); return; }
      if (S.phase !== 'ready') return;
      if (key === ' ' || key === 'Enter') { e.preventDefault(); if (S.aim) shoot(e.timeStamp && e.timeStamp < 1e12 ? e.timeStamp : pnow()); return; }
      var step = 0.12;
      if (key.indexOf('Arrow') === 0) {
        e.preventDefault();
        var a = S.aim || { x: 0, y: 0.5 };
        if (key === 'ArrowLeft') a.x -= step; if (key === 'ArrowRight') a.x += step; if (key === 'ArrowUp') a.y += step; if (key === 'ArrowDown') a.y -= step;
        S.aim = { x: clamp(a.x, -1, 1), y: clamp(a.y, 0, 1) };
      }
    });
    canvas.setAttribute('tabindex', '0');

    /* ----- DOM panel (game over / leaderboard) ----- */
    var panel = root.querySelector('.fevr-panel');
    var panelMode = 'over';
    function panelOpen() { return panel && !panel.hidden; }
    function q(sel) { return panel.querySelector(sel); }

    var lb = root.querySelector('[data-fevr-lb]');
    var lastBoard = { entries: [], plays: null };
    function emptyRow(ol, text) { ol.innerHTML = ''; var li = document.createElement('li'); li.className = 'fevr-board__empty'; li.textContent = text; ol.appendChild(li); }
    function addRow(ol, rank, name, score, mine) {
      var li = document.createElement('li');
      if (mine) li.className = 'is-me';
      [['r', rank], ['n', name], ['s', pad5(score)]].forEach(function (p) { var sp = document.createElement('span'); sp.className = p[0]; sp.textContent = p[1]; li.appendChild(sp); });
      ol.appendChild(li);
    }

    function renderBoard(entries, myNick, myScore, plays) {
      lastBoard = { entries: entries || [], plays: plays };
      if (lb) {
        var ol = lb.querySelector('.fevr-lb__list'), live = lb.querySelector('.fevr-lb__live');
        live.textContent = typeof plays === 'number' && plays > 0 ? 'LIVE · ' + plays + (plays === 1 ? ' PLAY' : ' PLAYS') : 'LIVE';
        if (!entries || !entries.length) emptyRow(ol, api.mode === 'practice' ? 'LEADERBOARD GOES LIVE WITH THE DROP' : 'NO SCORES YET. BE FIRST.');
        else { ol.innerHTML = ''; entries.forEach(function (en) { addRow(ol, en.rank < 10 ? '0' + en.rank : en.rank, en.nickname, en.score, false); }); }
        renderMine(entries || []);
      }
      updateHint();
    }

    /* "YOUR BEST": this player's best score on this device, ranked if it is in the top 10. */
    function renderMine(entries) {
      if (!lb) return;
      var me = lb.querySelector('.fevr-lb__me');
      if (api.mode !== 'live' || !(S.best > 0)) { emptyRow(me, api.mode === 'live' ? 'PLAY A RUN TO SET YOUR SCORE.' : 'PRACTICE MODE: SCORES AREN\'T RANKED.'); return; }
      var nick = '';
      try { nick = window.localStorage.getItem('fevr_nick') || ''; } catch (e) { /* ignore */ }
      var rank = '—';
      entries.forEach(function (en) { if (rank === '—' && en.score === S.best && (!nick || en.nickname === nick)) rank = en.rank < 10 ? '0' + en.rank : en.rank; });
      me.innerHTML = '';
      addRow(me, rank, nick || 'YOU', S.best, true);
    }

    function loadBoard() {
      if (!lb) return;
      api.leaderboard().then(function (r) { renderBoard(r && r.entries || [], null, null, r && r.plays); }).catch(function () { emptyRow(lb.querySelector('.fevr-lb__list'), 'COULDN\'T LOAD THE BOARD'); });
    }

    function updateHint() {
      if (!panel) return;
      var hint = panel.querySelector('.fevr-panel__hint'), e = lastBoard.entries;
      var show = panelMode === 'over' && api.mode === 'live' && !S.submitted && e.length >= 10 && S.score <= e[e.length - 1].score;
      hint.textContent = show ? 'SCORE ' + (e[e.length - 1].score + 100) + '+ TO MAKE THE BOARD' : '';
    }

    function showPanel(mode) {
      if (!panel) return;
      panelMode = mode;
      var isOver = mode === 'over';
      q('.fevr-panel__title').textContent = isOver ? 'GAME OVER' : 'LEADERBOARD';
      q('.fevr-panel__scorebox').hidden = !isOver;
      q('.fevr-panel__score').textContent = pad5(S.score);
      q('.fevr-panel__best').textContent = isOver ? (S.newBest ? 'NEW PERSONAL BEST!' : 'BEST ' + pad5(S.best)) : '';
      var drop = root.getAttribute('data-drop-label');
      q('.fevr-panel__drop').textContent = drop ? drop.toUpperCase() : '';
      var form = q('.fevr-panel__form'), msg = q('.fevr-panel__msg');
      var canSubmit = isOver && api.mode === 'live' && !S.submitted && S.score >= 0;
      form.hidden = !canSubmit;
      msg.className = 'fevr-panel__msg'; msg.textContent = '';
      if (isOver && api.mode === 'practice') msg.textContent = 'PRACTICE RUN. SCORES AREN\'T RANKED.';
      if (isOver && S.submitted && S.lastEntry) setSubmittedMsg(S.lastEntry);
      q('[data-act="close"]').hidden = isOver;
      var shareBtn = q('[data-act="share"]'); if (shareBtn) shareBtn.hidden = !(isOver && S.score > 0);
      q('[data-act="replay"]').textContent = isOver ? 'PLAY AGAIN' : 'PLAY';
      panel.hidden = false;
      root.classList.add('is-panel');
      loadBoard(); updateHint();
      var input = q('input[name="nickname"]');
      if (canSubmit && tryAutoSubmit()) return;
      if (canSubmit) { try { input.value = window.localStorage.getItem('fevr_nick') || input.value || ''; q('input[name="email"]').value = window.localStorage.getItem('fevr_email') || q('input[name="email"]').value || ''; } catch (e) { /* ignore */ } setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }, 50); }
      else { var b = q('[data-act="replay"]'); setTimeout(function () { try { b.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }, 50); }
    }

    /* Returning players: once a name + email has been saved on this device, every later run that beats the last submitted score is sent to the board automatically, so a new best never gets stranded as "personal best" only. */
    function savedIdentity() {
      try {
        var n = Core.cleanNickname(window.localStorage.getItem('fevr_nick') || ''), em = Core.cleanEmail(window.localStorage.getItem('fevr_email') || '');
        return n && em ? { nick: n, email: em } : null;
      } catch (e) { return null; }
    }
    function subBest() { try { return parseInt(window.localStorage.getItem('fevr_sub_best_' + (root.getAttribute('data-drop-label') || '')) || '0', 10) || 0; } catch (e) { return 0; } }
    function setSubBest(v) { try { window.localStorage.setItem('fevr_sub_best_' + (root.getAttribute('data-drop-label') || ''), String(v)); } catch (e) { /* ignore */ } }
    function tryAutoSubmit() {
      var id = savedIdentity();
      if (!id || !S.sess) return false;
      var msg = q('.fevr-panel__msg'), form = q('.fevr-panel__form');
      if (!(S.score > 0)) return false;
      if (S.score <= subBest()) { form.hidden = true; msg.className = 'fevr-panel__msg'; msg.textContent = 'YOUR TOP SCORE (' + pad5(subBest()) + ') IS STILL ON THE BOARD.'; return false; }
      form.hidden = true; msg.className = 'fevr-panel__msg'; msg.textContent = 'SAVING YOUR SCORE...';
      var sess = S.sess;
      if (S.autoSent === sess) return false;
      S.autoSent = sess;
      api.submit(sess, id.nick, id.email).then(function (r) {
        if (S.sess !== sess) return;
        if (!r || r.ok === false) { S.autoSent = null; form.hidden = false; msg.className = 'fevr-panel__msg is-bad'; msg.textContent = (r && r.error === 'already_submitted') ? 'ALREADY SUBMITTED.' : 'COULDN\'T SAVE. TAP SUBMIT TO TRY AGAIN.'; return; }
        S.submitted = true; S.lastEntry = { nickname: r.nickname, score: r.score, status: r.status, rank: r.rank };
        setSubBest(Math.max(subBest(), r.score));
        setSubmittedMsg(S.lastEntry);
        renderBoard(r.entries, r.nickname, r.score, r.plays);
      }).catch(function () { if (S.sess !== sess) return; S.autoSent = null; form.hidden = false; msg.className = 'fevr-panel__msg is-bad'; msg.textContent = 'NO CONNECTION. TAP SUBMIT TO TRY AGAIN.'; });
      return false;
    }

    /* Adds the email to the store's mailing list through Shopify's own newsletter form endpoint. Best effort. */
    function subscribe(email) {
      try {
        var body = 'form_type=customer&utf8=%E2%9C%93&contact%5Btags%5D=newsletter&contact%5Bemail%5D=' + encodeURIComponent(email);
        fetch('/contact', { method: 'POST', credentials: 'same-origin', redirect: 'manual', headers: { 'content-type': 'application/x-www-form-urlencoded' }, body: body }).catch(function () { /* ignore */ });
      } catch (e) { /* ignore */ }
    }


    /* ----- share card (1080x1920 story image) ----- */
    function buildShareCard() {
      var w = 270, h = 480, cv = document.createElement('canvas'); cv.width = w; cv.height = h;
      var g = cv.getContext('2d'); g.imageSmoothingEnabled = false;
      function t(str, x, y, sc, col, al) { return Art.drawText(g, str, x, y, sc, col, al); }
      g.fillStyle = '#000'; g.fillRect(0, 0, w, h);
      g.fillStyle = '#0c0c0c'; for (var y0 = 0; y0 < h; y0 += 8) g.fillRect(0, y0, w, 4);
      g.fillStyle = '#ff6a00'; g.fillRect(0, 0, w, 6); g.fillRect(0, h - 6, w, 6);
      t('FEVR', w / 2, 40, 9, '#ffffff', 'center');
      t('PENALTY SHOOTOUT', w / 2, 112, 2, '#ff6a00', 'center');
      var K = R.KEEPERS[Math.min(S.level, R.KEEPERS.length - 1)], sp = Art.buildKeeperSprite(K.id, 0);
      g.drawImage(sp.cv, 0, 0, sp.cv.width, sp.cv.height, w / 2 - 78, 345 - sp.fy * 3, sp.cv.width * 3, sp.cv.height * 3);
      t('I SCORED', w / 2, 366, 2, '#9a9a9a', 'center');
      t(pad5(S.score), w / 2, 388, 7, '#ff6a00', 'center');
      t('BEST STREAK X' + (S.bestStreak || 0) + '   KEEPER ' + (Math.min(S.level, R.KEEPERS.length - 1) + 1) + ': ' + K.name, w / 2, 442, 1, '#ffffff', 'center');
      t('CAN YOU BEAT IT? FEVROFFICIAL.COM', w / 2, 460, 1, '#6a6a6a', 'center');
      var out = document.createElement('canvas'); out.width = 1080; out.height = 1920;
      var o = out.getContext('2d'); o.imageSmoothingEnabled = false; o.drawImage(cv, 0, 0, 1080, 1920);
      return out;
    }
    function shareScore() {
      var btn = q('[data-act="share"]'), msg = q('.fevr-panel__msg');
      var text = 'I scored ' + S.score + ' on the FEVR Penalty Shootout. Beat it: https://fevrofficial.com';
      var cv; try { cv = buildShareCard(); } catch (e) { return; }
      cv.toBlob(function (blob) {
        if (!blob) return;
        var file; try { file = new File([blob], 'fevr-penalty-score.png', { type: 'image/png' }); } catch (e) { file = null; }
        if (file && navigator.canShare && navigator.canShare({ files: [file] }) && navigator.share) {
          navigator.share({ files: [file], text: text }).catch(function () { /* cancelled */ });
        } else {
          var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'fevr-penalty-score.png';
          document.body.appendChild(a); a.click(); a.remove();
          setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
          if (btn) { msg.className = 'fevr-panel__msg is-ok'; msg.textContent = 'IMAGE SAVED. POST IT TO YOUR STORY.'; }
        }
      }, 'image/png');
    }

    function hidePanel() { if (panel) { panel.hidden = true; root.classList.remove('is-panel'); } }

    function setSubmittedMsg(r) {
      var msg = q('.fevr-panel__msg');
      if (r.status === 'review') { msg.className = 'fevr-panel__msg is-warn'; msg.textContent = 'SCORE SAVED. IT NEEDS A QUICK CHECK BEFORE IT SHOWS ON THE BOARD.'; }
      else { msg.className = 'fevr-panel__msg is-ok'; msg.textContent = r.rank ? 'YOU\'RE #' + r.rank + ' RIGHT NOW. KEEP GOING.' : 'SCORE SAVED.'; }
    }

    if (panel) {
      q('.fevr-panel__form').addEventListener('submit', function (e) {
        e.preventDefault();
        var input = q('input[name="nickname"]'), btn = q('.fevr-panel__form button'), msg = q('.fevr-panel__msg');
        var nick = Core.cleanNickname(input.value);
        if (!nick) { msg.className = 'fevr-panel__msg is-bad'; msg.textContent = 'THAT NAME ISN\'T ALLOWED. USE 2-12 LETTERS OR NUMBERS.'; return; }
        var emailInput = q('input[name="email"]');
        var email = Core.cleanEmail(emailInput.value);
        if (!email) { msg.className = 'fevr-panel__msg is-bad'; msg.textContent = 'ENTER A VALID EMAIL TO GET ON THE BOARD.'; try { emailInput.focus(); } catch (e0) { /* ignore */ } return; }
        btn.disabled = true; msg.className = 'fevr-panel__msg'; msg.textContent = 'SAVING...';
        api.submit(S.sess, nick, email).then(function (r) {
          btn.disabled = false;
          if (!r || r.ok === false) {
            var map = { bad_nickname: 'THAT NAME ISN\'T ALLOWED. TRY ANOTHER.', bad_email: 'THAT EMAIL LOOKS WRONG. CHECK IT.', already_submitted: 'ALREADY SUBMITTED.', drop_closed: 'THIS DROP HAS ENDED.', rate_limited: 'SLOW DOWN. TRY AGAIN.' };
            msg.className = 'fevr-panel__msg is-bad'; msg.textContent = map[r && r.error] || 'COULDN\'T SAVE. TRY AGAIN.'; return;
          }
          S.submitted = true; S.lastEntry = { nickname: r.nickname, score: r.score, status: r.status, rank: r.rank };
          try { window.localStorage.setItem('fevr_nick', r.nickname); window.localStorage.setItem('fevr_email', email); } catch (e2) { /* ignore */ }
          setSubBest(Math.max(subBest(), r.score));
          subscribe(email);
          q('.fevr-panel__form').hidden = true; setSubmittedMsg(S.lastEntry);
          renderBoard(r.entries, r.nickname, r.score, r.plays);
        }).catch(function () { btn.disabled = false; msg.className = 'fevr-panel__msg is-bad'; msg.textContent = 'NO CONNECTION. TRY AGAIN.'; });
      });
      panel.addEventListener('click', function (e) {
        var act = e.target && e.target.getAttribute && e.target.getAttribute('data-act');
        if (act === 'replay') { hidePanel(); S.phase = 'intro'; startRun(); }
        if (act === 'close') hidePanel();
        if (act === 'share') shareScore();
      });
      panel.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panelMode === 'board') hidePanel(); });
    }

    var lbBtn = root.querySelector('[data-act="leaderboard"]');
    if (lbBtn) lbBtn.addEventListener('click', function () { if (lb && lb.scrollIntoView) lb.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' }); });
    var sndBtn = root.querySelector('[data-act="sound"]');
    function syncSnd() { if (sndBtn) { sndBtn.textContent = 'SOUND: ' + (audio.isMuted() ? 'OFF' : 'ON'); sndBtn.setAttribute('aria-pressed', audio.isMuted() ? 'false' : 'true'); } }
    if (sndBtn) { sndBtn.addEventListener('click', function () { audio.setMuted(!audio.isMuted()); syncSnd(); }); syncSnd(); }

    /* ----- drawing ----- */
    function T(str, x, y, scale, color, align, outline) { return Art.drawText(ctx, str, x, y, scale, color, align, outline); }
    function rect(x, y, w, h, c) { ctx.fillStyle = c; ctx.fillRect(x, y, w, h); }

    function drawPitch() {
      rect(0, 0, W, H, C.INK);
      for (var y = GROUND, i = 0; y < H; y += 16, i++) if (i % 2 === 0) rect(0, y, W, 16, '#0a0a0a');
      // lines
      var lc = '#2c2c2c';
      rect(0, GROUND, W, 1, '#8a8a8a');
      rect(6, 196, W - 12, 1, lc); rect(6, GROUND, 1, 84, lc); rect(W - 7, GROUND, 1, 84, lc);
      rect(46, 150, W - 92, 1, lc); rect(46, GROUND, 1, 38, lc); rect(W - 47, GROUND, 1, 38, lc);
      // D arc
      ctx.fillStyle = lc;
      for (var a = 0.15; a < Math.PI - 0.15; a += 0.04) ctx.fillRect(Math.round(CX + Math.cos(a) * 34), Math.round(196 + Math.sin(a) * 18), 1, 1);
      // spot
      rect(BALL_X - 1, BALL_Y + 7, 3, 1, '#9a9a9a');
    }

    function drawNet(now, impact) {
      var x0 = 23, x1 = 157, y0 = INNER_TOP, y1 = GROUND;
      var rip = impact && now - impact.at < 700 ? impact : null;
      function off(px, py) {
        if (!rip) return 0;
        var t = (now - rip.at) / 700, d = Math.hypot(px - rip.x, py - rip.y);
        return Math.sin(d * 0.35 - t * 14) * 3.2 * Math.exp(-d / 26) * (1 - t);
      }
      ctx.fillStyle = rip ? '#4a4a4a' : '#262626';
      for (var x = x0 + 4; x < x1; x += 7) for (var y = y0; y < y1; y += 2) ctx.fillRect(Math.round(x + off(x, y)), y, 1, 1);
      for (var yy = y0 + 4; yy < y1; yy += 6) for (var xx = x0; xx < x1; xx += 2) ctx.fillRect(xx, Math.round(yy + off(xx, yy)), 1, 1);
    }

    function drawGoalFrame() {
      rect(20, BAR_TOP, 140, 3, C.WHITE); rect(20, BAR_TOP, 3, GROUND - BAR_TOP + 1, C.WHITE); rect(157, BAR_TOP, 3, GROUND - BAR_TOP + 1, C.WHITE);
    }

    /* Idle animation per keeper: ax/px = sideways sway amount/period, hop/hp = bounce, tilt/tp = rock, vy/vp = float. */
    var IDLE = {
      baby: { ax: 1, px: 900, tilt: 0.10, tp: 210 }, gmac: { ax: 2, px: 520, hop: 3, hp: 150 }, sunday: { ax: 5, px: 560, tilt: 0.07, tp: 600 },
      nonleague: { ax: 3, px: 420, tilt: 0.03, tp: 420 }, championship: { ax: 1, px: 500, hop: 3, hp: 220 }, premier: { ax: 1, px: 900, tilt: 0.025, tp: 900 },
      courtois: { tilt: 0.03, tp: 900, hop: 1, hp: 700 }, octopus: { tilt: 0.07, tp: 280, hop: 2, hp: 360 }, robo: {}, 'void': { vy: 3, vp: 600 }
    };

    function keeperPose(now) {
      var level = S.displayLevel;
      var s0 = sprite(level, 0), s1 = sprite(level, 1);
      var restX = CX, restY = GROUND - (s0.fy - s0.py);
      var d = S.dive, kid = R.KEEPERS[level].id;
      if (!d) {
        var I = IDLE[kid] || {}, rmo = reduceMotion();
        var sx = rmo || !I.ax ? 0 : Math.round(Math.sin(now / I.px) * I.ax);
        var hy = rmo || !I.hop ? 0 : -Math.round(Math.abs(Math.sin(now / I.hp)) * I.hop);
        var fy = rmo || !I.vy ? 0 : Math.round(Math.sin(now / I.vp) * I.vy);
        var glitch = !rmo && kid === 'robo' && Math.floor(now / 1100) % 5 === 0 && Math.floor(now / 55) % 2 ? 2 : 0;
        return { spr: s0, x: restX + sx + glitch, y: restY + hy + fy, ang: rmo || !I.tilt ? 0 : Math.sin(now / I.tp) * I.tilt, idle: true, id: kid };
      }
      if (kid === 'octopus' && d.kind !== 'S') { // the octopus doesn't dive: his arms stretch out towards the ball
        return { spr: s0, x: restX, y: restY, ang: 0, arm: { tx: d.tx, ty: d.ty, e: easeOut(clamp((now - d.start) / DIVE_MS, 0, 1)) } };
      }
      var p = clamp((now - d.start) / DIVE_MS, 0, 1), e = easeOut(p);
      if (d.kind === 'S') {
        var sit = S.displayLevel === 0 ? Math.round(3 * e) : 0;
        return { spr: s0, x: restX + (d.shift || 0) * e, y: restY + sit, ang: 0 };
      }
      var vx = d.tx - restX, vy = d.ty - restY, len = Math.max(1, Math.hypot(vx, vy)), dx = vx / len, dy = vy / len;
      var tip = s1.tip;
      var travel = Math.max(0, len - tip);
      var px = restX + dx * travel, py = Math.min(GROUND - 5, restY + dy * travel);
      var ang = clamp(Math.atan2(dx, -dy), -1.65, 1.65);
      return { spr: p > 0.12 ? s1 : s0, x: lerp(restX, px, e), y: lerp(restY, py, e), ang: ang * e };
    }

    function drawKeeper(now, opts) {
      var pose = keeperPose(now);
      opts = opts || {};
      ctx.save();
      ctx.translate(Math.round(pose.x + (opts.dx || 0)), Math.round(pose.y + (opts.dy || 0)));
      if (pose.ang) ctx.rotate(pose.ang);
      ctx.imageSmoothingEnabled = false;
      ctx.drawImage(pose.spr.cv, -pose.spr.px, -pose.spr.py);
      if (opts.flash) { ctx.globalCompositeOperation = 'source-atop'; ctx.fillStyle = 'rgba(255,255,255,' + opts.flash + ')'; ctx.fillRect(-pose.spr.px, -pose.spr.py, pose.spr.cv.width, pose.spr.cv.height); }
      ctx.restore();
      if (pose.idle && pose.id === 'baby' && !opts.flash) { // crying: tears roll down
        ctx.fillStyle = '#00f0ff';
        [-2, 2].forEach(function (ex, i) { ctx.fillRect(Math.round(pose.x + ex), Math.round(pose.y - 4 + ((now / 110 + i * 3) % 7)), 1, 2); });
      }
      if (pose.arm && pose.arm.e > 0.02) drawOctoArms(now, pose);
      if (S.displayLevel === 9 && !opts.noAura) { // the void pulses
        ctx.fillStyle = 'rgba(255,255,255,0.35)';
        var pulse = Math.floor(now / 140) % 4;
        for (var i = 0; i < 10; i++) { var a = i * 0.628 + now / 700; ctx.fillRect(Math.round(CX + Math.cos(a) * (22 + pulse)), Math.round(GROUND - 20 + Math.sin(a) * (18 + pulse)), 1, 1); }
      }
    }

    function drawOctoArms(now, pose) {
      var ox = pose.x, oy = pose.y, a = pose.arm, e = a.e;
      [-1, 1].forEach(function (side, j) {
        var sx = ox + side * 5, sy = oy + 4;
        var ex = sx + (a.tx + side * 3 - sx) * e, ey = sy + (a.ty + (j ? 2 : -2) - sy) * e;
        var len = Math.hypot(ex - sx, ey - sy), n = Math.max(2, Math.ceil(len / 2));
        var nx = len ? -(ey - sy) / len : 0, ny = len ? (ex - sx) / len : 0;
        for (var i = 0; i <= n; i++) {
          var t = i / n, wob = Math.sin(i * 0.8 - now / 70) * 1.4 * Math.sin(t * Math.PI);
          var px = Math.round(sx + (ex - sx) * t + nx * wob), py = Math.round(sy + (ey - sy) * t + ny * wob), th = t < 0.5 ? 3 : 2;
          ctx.fillStyle = C.PINK; ctx.fillRect(px - 1, py - 1, th, th);
          if (i % 3 === 1 && t > 0.2) { ctx.fillStyle = '#ffffff'; ctx.fillRect(px, py, 1, 1); }
        }
        ctx.fillStyle = C.PINK; ctx.fillRect(Math.round(ex) - 2, Math.round(ey) - 2, 5, 5);
        ctx.fillStyle = '#ffffff'; ctx.fillRect(Math.round(ex) - 1, Math.round(ey) - 1, 3, 3);
      });
    }

    function targetPx(sh) {
      return { x: CX + clamp(sh.x, -1.4, 1.4) * HALF, y: GROUND - clamp(sh.y, 0, 1.7) * HALF };
    }

    function drawKicker(now) {
      var x = BALL_X - 14, y = 216;
      var phase = 0;
      if (S.phase === 'windup') phase = 1;
      if ((S.phase === 'flight' || S.phase === 'result') && now - S.kickAt < 220) phase = 2;
      if (S.phase === 'ready' && S.aim) phase = 0;
      rect(x + 1, y, 7, 6, '#d9a37a'); rect(x + 1, y, 7, 3, '#111'); // head (back of head)
      rect(x, y + 6, 9, 9, C.WHITE); rect(x + 3, y + 8, 3, 1, C.INK); rect(x + 3, y + 10, 3, 1, C.INK); // shirt + number mark
      rect(x, y + 15, 9, 4, C.INK); rect(x, y + 15, 9, 1, C.G2);
      rect(x + 1, y + 19, 3, 5, '#d9a37a'); rect(x + 1, y + 22, 3, 3, C.WHITE);
      if (phase === 0) { rect(x + 5, y + 19, 3, 5, '#d9a37a'); rect(x + 5, y + 22, 3, 3, C.WHITE); }
      if (phase === 1) { rect(x + 5, y + 19, 3, 3, '#d9a37a'); rect(x + 7, y + 21, 3, 3, '#d9a37a'); rect(x + 8, y + 23, 4, 2, C.WHITE); }
      if (phase === 2) { rect(x + 5, y + 18, 4, 3, '#d9a37a'); rect(x + 8, y + 15, 3, 3, '#d9a37a'); rect(x + 9, y + 12, 4, 2, C.WHITE); }
      rect(x, y + 25, 4, 2, '#111');
    }

    function drawHud(now) {
      T('SCORE', 4, 3, 1, '#7a7a7a');
      T(pad5(S.score), 4, 12, 2, C.WHITE);
      var flashing = now < S.lifeFlashUntil && Math.floor(now / 80) % 2 === 0;
      for (var i = 0; i < (S.rules.lives || 3); i++) {
        var hx = W - 4 - 27 + i * 10;
        if (i < S.lives) Art.drawHeart(ctx, hx, 4, C.WHITE);
        else Art.drawHeartOutline(ctx, hx, 4, flashing ? C.RED : C.G2);
      }
      if (S.best > 0) T('BEST ' + pad5(S.best), W - 4, 15, 1, '#6a6a6a', 'right');
      if (S.streak >= 1 && S.phase !== 'intro') {
        var big = S.streak >= 3, pulse = now - S.resultAt < 300 && S.phase === 'result';
        T('STREAK ' + S.streak + '  X' + (Math.round(S.mult * 100) / 100), 4, 29, 1, big || pulse ? C.NEON : '#b84a00');
      }
      // keeper label
      var K = R.KEEPERS[S.displayLevel];
      rect(0, 114, W, 22, C.INK);
      T('LV' + (S.displayLevel + 1), 4, 117, 1, '#7a7a7a');
      T(K.name, CX, 117, 1, C.WHITE, 'center');
      T(K.tag, CX, 126, 1, '#6a6a6a', 'center');
      var inLevel = S.attempt - S.displayLevel * R.SHOTS_PER_LEVEL;
      if (S.displayLevel === R.KEEPERS.length - 1) inLevel = ((S.attempt - S.displayLevel * R.SHOTS_PER_LEVEL) % R.SHOTS_PER_LEVEL + R.SHOTS_PER_LEVEL) % R.SHOTS_PER_LEVEL;
      inLevel = clamp(inLevel, 0, R.SHOTS_PER_LEVEL);
      for (var p = 0; p < R.SHOTS_PER_LEVEL; p++) {
        var done = p < inLevel;
        rect(W - 4 - 3 * 6 + p * 6 + 1, 118, 4, 4, done ? C.NEON : C.G2);
        if (!done) rect(W - 4 - 3 * 6 + p * 6 + 2, 119, 2, 2, C.INK);
      }
    }

    function drawMeter(now) {
      var m = METER, ready = S.phase === 'ready', running = ready && now >= S.meterStart;
      var half = S.meterSweet;
      rect(m.x - 1, m.y - 1, m.w + 2, m.h + 2, ready ? C.WHITE : C.G2);
      rect(m.x, m.y, m.w, m.h, C.INK);
      var zx = Math.round(m.x + (0.5 - half) * m.w), zw = Math.round(half * 2 * m.w);
      for (var gx = 0; gx < zw; gx++) { // yellow at the edges -> green in the centre (best timing)
        var gt = 1 - Math.abs((gx + 0.5) / zw - 0.5) * 2, dim = running ? 1 : 0.4;
        ctx.fillStyle = 'rgb(' + Math.round((255 - 255 * gt) * dim) + ',' + Math.round((212 + 20 * gt) * dim) + ',' + Math.round((0 + 70 * gt) * dim) + ')';
        ctx.fillRect(zx + gx, m.y + 1, 1, m.h - 2);
      }
      if (ready) {
        if (running) {
          var pos = R.meterPos(now - S.meterStart, S.meterPeriod);
          var cx = Math.round(m.x + pos * (m.w - 2));
          var inZone = Math.abs(pos - 0.5) <= half;
          rect(cx - 1, m.y - 3, 3, m.h + 6, inZone ? C.WHITE : C.CYAN);
          rect(cx, m.y - 3, 1, m.h + 6, C.INK);
        }
      }
      T('EARLY', m.x, m.y + 12, 1, '#555');
      T('LATE', m.x + m.w, m.y + 12, 1, '#555', 'right');
      // shoot button
      var pressed = now < S.btnDownUntil;
      var armed = ready && S.aim && now >= S.meterStart;
      var bc = armed ? C.NEON : (ready ? C.G1 : C.G2);
      rect(BTN.x, BTN.y, BTN.w, BTN.h, bc);
      rect(BTN.x + 2, BTN.y + 2, BTN.w - 4, BTN.h - 4, pressed ? C.WHITE : C.INK);
      var label = !ready ? '...' : !S.aim ? 'AIM FIRST' : now < S.meterStart ? 'READY...' : 'SHOOT';
      T(label, BTN.x + BTN.w / 2, BTN.y + 8, label === 'SHOOT' ? 2 : 1 + (label === 'AIM FIRST' ? 1 : 0), pressed ? C.INK : armed ? C.NEON : '#777', 'center');
      if (label === 'AIM FIRST') { /* scale 2 text fits 9 chars? */ }
    }

    function drawAim(now) {
      if (!S.aim || (S.phase !== 'ready' && S.phase !== 'windup')) return;
      var px = Math.round(CX + S.aim.x * HALF), py = Math.round(GROUND - S.aim.y * HALF);
      var pulse = Math.floor(now / 160) % 2;
      var c = C.CYAN, g = 3 + pulse;
      rect(px - g - 4, py, 4, 1, c); rect(px + g + 1, py, 4, 1, c); rect(px, py - g - 4, 1, 4, c); rect(px, py + g + 1, 1, 4, c);
      rect(px, py, 1, 1, C.WHITE);
    }

    function drawBallLayer(now) {
      var pos = S.ballPos;
      if (pos) { Art.drawBall(ctx, pos.x, pos.y, pos.r, pos.spin); return; }
      // resting ball (with shadow)
      rect(BALL_X - 4, BALL_Y + 5, 9, 2, '#1d1d1d');
      var bob = (S.phase === 'ready' && !reduceMotion()) ? (Math.floor(now / 400) % 2) : 0;
      Art.drawBall(ctx, BALL_X, BALL_Y - bob, 5, 0.4);
    }

    function drawBanner(now) {
      var hintY = 168;
      if (S.phase === 'ready') {
        if (now < S.errUntil) { /* error shown below */ }
        else if (!S.aim) T('TAP THE GOAL TO AIM', CX, hintY, 1, Math.floor(now / 450) % 2 ? C.CYAN : C.WHITE, 'center', C.INK);
        else if (now >= S.meterStart) T('TAP SHOOT WHEN IT\'S GREEN', CX, hintY, 1, '#00e05a', 'center', C.INK);
        else T('GET READY...', CX, hintY, 1, C.G1, 'center', C.INK);
      }
      if (now < S.errUntil && S.err) T(S.err, CX, 150, 1, C.RED, 'center', C.INK);
    }

    function drawResult(now) {
      if (S.phase !== 'result' && !(S.phase === 'over')) return;
      if (!S.res) return;
      var age = now - S.resultAt;
      if (S.resultKind === 'goal') {
        var pop = age < 140 ? 1 + (1 - age / 140) * 0.0 : 1;
        rect(0, 134, W, 70, 'rgba(0,0,0,0.82)');
        T('GOAL!', CX, 142 + (age < 120 ? -4 : 0), 5, C.NEON, 'center');
        T('+' + S.lastDelta, CX, 184, 2, C.WHITE, 'center');
        if (S.streak >= 2) T('STREAK X' + (Math.round(S.mult * 100) / 100), CX, 198 - 0, 1, C.NEON, 'center');
      } else {
        var lines = Art.wrap(S.resultMsg, 26);
        var boxH = 44 + lines.length * 10;
        rect(0, 130, W, boxH, 'rgba(0,0,0,0.82)');
        T(S.resultText, CX, 136, 4, C.WHITE, 'center');
        lines.forEach(function (ln, i) { T(ln, CX, 168 + i * 10, 1, C.RED, 'center'); });
      }
    }

    function drawFlash(now) {
      if (now < S.flashUntil) {
        var a = clamp((S.flashUntil - now) / 260, 0, 1) * (S.flashColor === C.NEON ? 0.18 : 0.14);
        ctx.fillStyle = S.flashColor === C.NEON ? 'rgba(255,106,0,' + a + ')' : 'rgba(255,42,42,' + a + ')';
        ctx.fillRect(0, 0, W, H);
      }
    }

    function drawIntro(now) {
      rect(0, 0, W, H, C.INK);
      for (var y = 178, i = 0; y < H; y += 16, i++) if (i % 2 === 0) rect(0, y, W, 16, '#0a0a0a');
      rect(0, 178, W, 1, '#8a8a8a');
      // mini goal with the first keeper
      rect(50, 138, 80, 3, C.WHITE); rect(50, 138, 3, 41, C.WHITE); rect(127, 138, 3, 41, C.WHITE);
      ctx.fillStyle = '#262626';
      for (var nx = 56; nx < 127; nx += 7) for (var ny = 141; ny < 178; ny += 2) ctx.fillRect(nx, ny, 1, 1);
      S.displayLevel = 0;
      drawKeeper(now, { noAura: true, dy: 66 });
      T('FEVR', CX, 52, 3, C.WHITE, 'center');
      T('PENALTY SHOOTOUT', CX, 80, 1, C.NEON, 'center');
      rect(BALL_X - 1, 212, 3, 1, '#9a9a9a');
      Art.drawBall(ctx, BALL_X, 205, 5, now / 300);
      T('3 LIVES. STREAKS MULTIPLY.', CX, 230, 1, C.G1, 'center');
      if (Math.floor(now / 500) % 2 === 0) T('TAP TO START', CX, 258, 2, C.CYAN, 'center');
      if (S.practiceNote) T('PRACTICE MODE: NOT RANKED', CX, 292, 1, '#777', 'center');
      if (now < S.errUntil && S.err) T(S.err, CX, 304, 1, C.RED, 'center');
    }

    function drawLevelup(now) {
      var t = now - S.levelupAt;
      var swapAt = S.lvSwapAt || 600;
      if (t >= swapAt && !S.swapped) { S.swapped = true; markSeen(S.pendingLevelup.id); S.displayLevel = S.pendingLevelup.index; S.dive = null; S.flashUntil = now + 300; S.flashColor = C.CYAN; }
      var bounce = t >= swapAt ? Math.max(0, Math.sin(clamp((t - swapAt) / 450, 0, 1) * Math.PI)) * -10 : 0;
      var shake = t < swapAt ? (Math.floor(t / 40) % 2 ? 2 : -2) : 0;
      var flash = t < swapAt ? (Math.floor(t / 70) % 2 ? 0.85 : 0) : 0;
      drawKeeper(now, { dx: shake, dy: bounce, flash: flash });
      // rings
      var cx = CX, cy = GROUND - 18;
      for (var i = 0; i < (S.lvQuick ? 0 : 3); i++) {
        var rt = (t - i * 140) / 700;
        if (rt > 0 && rt < 1) {
          var r = 8 + rt * 56;
          ctx.fillStyle = 'rgba(0,240,255,' + (1 - rt) + ')';
          ctx.fillRect(Math.round(cx - r), Math.round(cy - r * 0.8), Math.round(r * 2), 1); ctx.fillRect(Math.round(cx - r), Math.round(cy + r * 0.8), Math.round(r * 2), 1);
          ctx.fillRect(Math.round(cx - r), Math.round(cy - r * 0.8), 1, Math.round(r * 1.6)); ctx.fillRect(Math.round(cx + r), Math.round(cy - r * 0.8), 1, Math.round(r * 1.6) + 1);
        }
      }
      if (t < swapAt) {
        if (!S.lvQuick) { rect(0, 50, W, 14, 'rgba(0,0,0,0.8)'); if (Math.floor(t / 100) % 2 === 0) T('EVOLVING...', CX, 54, 1, C.CYAN, 'center'); }
      } else {
        rect(0, 48, W, 34, 'rgba(0,0,0,0.85)');
        if (S.lvQuick) { T(S.pendingLevelup.name, CX, 58, 2, C.WHITE, 'center'); }
        else { T('NEW KEEPER', CX, 51, 1, C.CYAN, 'center'); T(S.pendingLevelup.name, CX, 62, 2, C.WHITE, 'center'); T(S.pendingLevelup.tag, CX, 77, 1, C.G1, 'center'); }
      }
      if (t > (S.lvTotal || LEVELUP_MS)) afterLevelup();
    }

    function drawErrorScreen() {
      rect(0, 120, W, 80, 'rgba(0,0,0,0.9)');
      T('CONNECTION LOST', CX, 134, 2, C.RED, 'center');
      T('YOUR SHOT IS SAFE.', CX, 160, 1, C.WHITE, 'center');
      T('TAP TO RETRY', CX, 176, 1, C.CYAN, 'center');
    }

    var impactFx = null;

    function loop() {
      var now = pnow();
      ctx.setTransform(k, 0, 0, k, 0, 0);
      ctx.imageSmoothingEnabled = false;

      // phase progression
      if (S.phase === 'windup' && S.pending && now - S.windupAt >= WINDUP_MS) {
        S.phase = 'flight'; S.flightAt = Math.max(now, S.pending.recv); S.kickAt = now;
        var sh = S.pending.res.shot, tgt = targetPx(sh);
        S.target = tgt;
        // keeper decision (from the server)
        var kk = S.pending.res.shot;
        var kind = kk.dive === 'S' ? 'S' : 'D';
        S.dive = { start: S.flightAt + 60, kind: kind, tx: CX + kk.kx * HALF, ty: GROUND - kk.ky * HALF, shift: 0 };
      }
      if (S.phase === 'flight') {
        var p = clamp((now - S.flightAt) / FLIGHT_MS, 0, 1);
        var tg = S.target;
        S.ballSpin += 0.5;
        S.ballPos = { x: lerp(BALL_X, tg.x, p), y: lerp(BALL_Y, tg.y, p) - Math.sin(p * Math.PI) * 10, r: lerp(5, 2.6, p), spin: S.ballSpin };
        if (p >= 1) { applyImpact(now); impactFx = S.res.shot.goal ? { at: now, x: tg.x, y: tg.y } : null; }
      }
      if (S.phase === 'result') {
        var sh2 = S.res.shot, age = now - S.resultAt, tg2 = S.target;
        if (sh2.result === 'save') { // ball is pushed away and drops
          var q2 = clamp(age / 420, 0, 1), dirx = tg2.x >= CX ? 1 : -1;
          S.ballSpin += 0.4;
          S.ballPos = { x: tg2.x + dirx * 26 * easeOut(q2), y: lerp(tg2.y, GROUND + 22, q2 * q2), r: lerp(2.6, 4.2, q2), spin: S.ballSpin };
        } else if (sh2.result === 'post' || sh2.result === 'bar') {
          var q3 = clamp(age / 380, 0, 1), dx3 = sh2.result === 'post' ? (tg2.x >= CX ? 1 : -1) * 30 : 0;
          S.ballSpin += 0.4;
          S.ballPos = { x: tg2.x + dx3 * easeOut(q3), y: lerp(tg2.y, tg2.y + 60, q3 * q3), r: lerp(2.6, 4.2, q3), spin: S.ballSpin };
        } else if (sh2.result === 'goal') {
          var q4 = clamp(age / 500, 0, 1);
          S.ballPos = { x: tg2.x, y: lerp(tg2.y, Math.min(GROUND - 3, tg2.y + 14), easeOut(q4)), r: 2.6, spin: S.ballSpin };
        } else { // wide/over: ball keeps flying
          var q5 = clamp(age / 500, 0, 1), dxo = tg2.x - BALL_X, dyo = tg2.y - BALL_Y;
          S.ballPos = { x: tg2.x + dxo * 0.5 * q5, y: tg2.y + dyo * 0.5 * q5, r: lerp(2.6, 1.6, q5), spin: S.ballSpin + age / 80 };
        }
        if (age > RESULT_MS) afterResult(now);
      }
      if (S.phase === 'over' && S.res) { /* hold final frame under the panel */ }

      // ----- draw -----
      if (S.phase === 'intro' || S.phase === 'starting') { drawIntro(now); drawFlash(now); requestAnimationFrame(loop); return; }

      var shaking = now < S.shakeUntil;
      ctx.save();
      if (shaking) {
        var amp = S.shakeAmp * ((S.shakeUntil - now) / 520);
        ctx.translate(Math.round((Math.random() * 2 - 1) * amp), Math.round((Math.random() * 2 - 1) * amp));
      }
      drawPitch();
      drawNet(now, impactFx);
      if (S.phase === 'levelup') drawLevelup(now); else drawKeeper(now);
      drawKicker(now);
      drawBallLayer(now);
      drawGoalFrame();
      drawAim(now);
      ctx.restore();

      drawHud(now);
      drawBanner(now);
      drawResult(now);
      drawMeter(now);
      if (S.phase === 'error') drawErrorScreen();
      drawFlash(now);

      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);

    loadBoard();
    var inst = { S: S, api: function () { return api; }, showPanel: showPanel, startRun: startRun, shoot: shoot, setAim: setAim, resize: resize };
    root.__fevr = inst;
    if (debug) window.__fevr = inst;
    root.classList.add('is-ready');
    return inst;
  }

  function init() {
    var nodes = document.querySelectorAll('.fevr-game');
    for (var i = 0; i < nodes.length; i++) mount(nodes[i]);
  }
  window.FevrPenalty = { mount: mount, init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
